var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfoOn = function SvgInfoOn(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    enableBackground: "new 0 0 16 17",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -565)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#0F40A9",
    cx: 28,
    cy: 574,
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.009,578h-1.383l1.383-6.48h1.377L28.009,578z M28.285,569.926c0-0.266,0.076-0.48,0.229-0.645 c0.152-0.164,0.367-0.246,0.645-0.246c0.207,0,0.375,0.052,0.504,0.155s0.193,0.261,0.193,0.472c0,0.277-0.078,0.496-0.234,0.656 s-0.361,0.24-0.615,0.24c-0.207,0-0.379-0.051-0.516-0.152C28.353,570.305,28.285,570.145,28.285,569.926z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoOn, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiANCgl4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIA0KCXhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTdweCIgdmlld0JveD0iMCAwIDE2IDE3IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNiAxNyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQoJPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIwIC01NjUpIj4NCgkJPGNpcmNsZSBmaWxsPSIjMEY0MEE5IiBjeD0iMjgiIGN5PSI1NzQiIHI9IjgiLz4NCgkJPGcgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAgICAiPg0KCQkJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTI4LjAwOSw1NzhoLTEuMzgzbDEuMzgzLTYuNDhoMS4zNzdMMjguMDA5LDU3OHogTTI4LjI4NSw1NjkuOTI2YzAtMC4yNjYsMC4wNzYtMC40OCwwLjIyOS0wLjY0NQ0KCQkJYzAuMTUyLTAuMTY0LDAuMzY3LTAuMjQ2LDAuNjQ1LTAuMjQ2YzAuMjA3LDAsMC4zNzUsMC4wNTIsMC41MDQsMC4xNTVzMC4xOTMsMC4yNjEsMC4xOTMsMC40NzJjMCwwLjI3Ny0wLjA3OCwwLjQ5Ni0wLjIzNCwwLjY1Ng0KCQkJcy0wLjM2MSwwLjI0LTAuNjE1LDAuMjRjLTAuMjA3LDAtMC4zNzktMC4wNTEtMC41MTYtMC4xNTJDMjguMzUzLDU3MC4zMDUsMjguMjg1LDU3MC4xNDUsMjguMjg1LDU2OS45MjZ6Ii8+DQoJCTwvZz4NCgk8L2c+DQo8L3N2Zz4NCg==";
export { ForwardRef as ReactComponent };